import { useEffect, useState } from 'react'

const OFFER_LIST_MANUAL_COOLDOWN_MS = 5000
let blockedUntil = 0
let timeout = null
const listeners = new Set()

const isBlocked = () => blockedUntil > Date.now()

const notify = () => {
  const blocked = isBlocked()
  listeners.forEach(listener => listener(blocked))
}

const startCooldown = () => {
  blockedUntil = Date.now() + OFFER_LIST_MANUAL_COOLDOWN_MS
  clearTimeout(timeout)
  notify()
  timeout = setTimeout(() => {
    blockedUntil = 0
    notify()
  }, OFFER_LIST_MANUAL_COOLDOWN_MS)
}

const subscribe = listener => {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

const useOfferListManualCooldown = () => {
  const [disabled, setDisabled] = useState(isBlocked)

  useEffect(() => subscribe(setDisabled), [])

  const runWithCooldown = action => {
    if (isBlocked()) {
      return
    }

    startCooldown()
    action()
  }

  return { disabled, runWithCooldown }
}

export default useOfferListManualCooldown
